import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumColumnType implements BaseEnumType {
  private static allValues: EnumColumnType[] = []; // make sure this is top-most
  
  public static none = new EnumColumnType(0, "None", "enum_column_type_none");
  public static string = new EnumColumnType(1, "String", "enum_column_type_string");
  public static date = new EnumColumnType(2, "Date", "enum_column_type_date");
  public static timestamp = new EnumColumnType(3, "Timestamp", "enum_column_type_timestamp");
  public static double = new EnumColumnType(4, "Double", "enum_column_type_double");
  public static boolean = new EnumColumnType(5, "Boolean", "enum_column_type_boolean");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumColumnType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumColumnType.none; }
  public isString() { return this === EnumColumnType.string; }
  public isDate() { return this === EnumColumnType.date; }
  public isTimestamp() { return this === EnumColumnType.timestamp; }
  public isDouble() { return this === EnumColumnType.double; }
  public isBoolean() { return this === EnumColumnType.boolean; }

  public static getValues(): readonly EnumColumnType[] {
    return EnumColumnType.allValues;
  }

  public static getValuesExcept0(): readonly EnumColumnType[] {
    return EnumColumnType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumColumnType {
    const found = EnumColumnType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumColumnType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumColumnType): EnumColumnType {
    const found = name ? EnumColumnType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumColumnType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumColumnType>): boolean {
    return this.key === other?.key;
  }
}